export default __webpack_public_path__ + "static/media/mo_mf_logo.defefd11.svg";